/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTeamUser = /* GraphQL */ `
  mutation CreateTeamUser(
    $input: CreateTeamUserInput!
    $condition: ModelTeamUserConditionInput
  ) {
    createTeamUser(input: $input, condition: $condition) {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTeamUser = /* GraphQL */ `
  mutation UpdateTeamUser(
    $input: UpdateTeamUserInput!
    $condition: ModelTeamUserConditionInput
  ) {
    updateTeamUser(input: $input, condition: $condition) {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTeamUser = /* GraphQL */ `
  mutation DeleteTeamUser(
    $input: DeleteTeamUserInput!
    $condition: ModelTeamUserConditionInput
  ) {
    deleteTeamUser(input: $input, condition: $condition) {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTeam = /* GraphQL */ `
  mutation CreateTeam(
    $input: CreateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    createTeam(input: $input, condition: $condition) {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam(
    $input: UpdateTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    updateTeam(input: $input, condition: $condition) {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTeam = /* GraphQL */ `
  mutation DeleteTeam(
    $input: DeleteTeamInput!
    $condition: ModelTeamConditionInput
  ) {
    deleteTeam(input: $input, condition: $condition) {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createMeeting = /* GraphQL */ `
  mutation CreateMeeting(
    $input: CreateMeetingInput!
    $condition: ModelMeetingConditionInput
  ) {
    createMeeting(input: $input, condition: $condition) {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const updateMeeting = /* GraphQL */ `
  mutation UpdateMeeting(
    $input: UpdateMeetingInput!
    $condition: ModelMeetingConditionInput
  ) {
    updateMeeting(input: $input, condition: $condition) {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const deleteMeeting = /* GraphQL */ `
  mutation DeleteMeeting(
    $input: DeleteMeetingInput!
    $condition: ModelMeetingConditionInput
  ) {
    deleteMeeting(input: $input, condition: $condition) {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const createAppLog = /* GraphQL */ `
  mutation CreateAppLog(
    $input: CreateAppLogInput!
    $condition: ModelAppLogConditionInput
  ) {
    createAppLog(input: $input, condition: $condition) {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const updateAppLog = /* GraphQL */ `
  mutation UpdateAppLog(
    $input: UpdateAppLogInput!
    $condition: ModelAppLogConditionInput
  ) {
    updateAppLog(input: $input, condition: $condition) {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const deleteAppLog = /* GraphQL */ `
  mutation DeleteAppLog(
    $input: DeleteAppLogInput!
    $condition: ModelAppLogConditionInput
  ) {
    deleteAppLog(input: $input, condition: $condition) {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const updateSettings = /* GraphQL */ `
  mutation UpdateSettings(
    $input: UpdateSettingsInput!
    $condition: ModelSettingsConditionInput
  ) {
    updateSettings(input: $input, condition: $condition) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteSettings = /* GraphQL */ `
  mutation DeleteSettings(
    $input: DeleteSettingsInput!
    $condition: ModelSettingsConditionInput
  ) {
    deleteSettings(input: $input, condition: $condition) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createSettings = /* GraphQL */ `
  mutation CreateSettings(
    $input: CreateSettingsInput!
    $condition: ModelSettingsConditionInput
  ) {
    createSettings(input: $input, condition: $condition) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
